import styled from "styled-components";

export const NotFoundComponentMainDiv = styled.main``;
export const NotFoundComponentHeroDiv = styled.section`
  padding: 200px 40px 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  > div {
    max-width: 1140px;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    gap: 10px;
  }
  .notfound-hero-container {
    display: flex;
    flex-flow: column;
    width: 100%;
    flex: 1;
    height: 736px;
    justify-content: center;
    align-items: center;
    gap: 60px;
  }
  .notfound-header-container {
    display: flex;
    gap: 16px;
    flex-flow: column;
    align-items: center;
  }
  .notfound-404-text-container {
    text-align: center;
   
    background-clip: border-box;

    > h1 {
      background: linear-gradient(
  90deg,
   rgb(255, 223, 125)  39%,    /* The Rich Base: Vibrant Gold */
  rgb(195, 220, 250) 60%,   /* The Metallic Flash: Icy Periwinkle */
  rgb(80, 140, 245) 79%     /* The Deep Pop: Vivid Cornflower Blue */
);
      background-clip: text;

      font-size: 320px;
      color: transparent;
    }
  }
  .notfound-header-text-container {
    max-width: 720px;
    text-align: center;
    > h1 {
      font-size: 72px;
    }
    > p {
      font-size: 18px;
      opacity: 0.7;
      line-height: 1.4em;
    }
  }
`;
